/**
 * Porta de entrada no navegador — o `index.js` do app nativo.
 */

import {AppRegistry} from 'react-native';

import './fontes.css';
import App from '../../App';
import {ticketeira} from '../config';
import {instalarAlerta} from './alerta';
import {txt} from '../ui/idioma';
import {vigiarAtualizacoes} from './atualizacao';
// Na carga, antes de qualquer tela: o Chrome avisa uma vez só que o site pode
// ser instalado, e cedo.
import './instalacao';

const raiz = document.getElementById('raiz');

/**
 * A ticketeira é conferida antes de qualquer tela, porque o tema inteiro sai
 * dela: um `config.js` errado derrubaria a primeira renderização e deixaria a
 * página em branco — que em portaria parece "o site caiu", não "o servidor
 * está mal configurado". Sem tema ainda, a mensagem sai sem cor de marca.
 */
function configuracaoValida(): boolean {
  try {
    ticketeira();
    return true;
  } catch (e) {
    const caixa = document.createElement('div');
    caixa.style.cssText =
      'margin:auto;max-width:420px;padding:24px;display:flex;flex-direction:column;' +
      'gap:20px;align-items:center;font:16px/1.5 system-ui,sans-serif;text-align:center';

    const aviso = document.createElement('p');
    aviso.textContent = (e as Error).message;
    aviso.style.cssText = 'margin:0';
    caixa.appendChild(aviso);

    // Reimplantação leva meio minuto, e sem botão o operador só sai daqui
    // sabendo recarregar a página — que num app instalado em tela cheia não é
    // gesto óbvio.
    const botao = document.createElement('button');
    botao.textContent = txt('Tentar de novo');
    botao.style.cssText =
      'font:600 16px system-ui,sans-serif;padding:14px 28px;border-radius:14px;' +
      'border:1px solid currentColor;background:transparent;color:inherit;cursor:pointer';
    botao.onclick = () => location.reload();
    caixa.appendChild(botao);

    raiz?.appendChild(caixa);
    return false;
  }
}

/**
 * O service worker guarda o app no aparelho — é o que faz a portaria abrir
 * sem rede — e avisa quando o servidor tem versão nova. Só no build: no
 * desenvolvimento ele serviria código velho.
 */
function registrarServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) {
    return;
  }
  vigiarAtualizacoes();
}

declare global {
  interface Window {
    /** Posto pelo index.html quando falta ao navegador o que o app exige. */
    VALIDADOR_INCOMPATIVEL?: string;
  }
}

// Navegador sem o necessário já recebeu a explicação do index.html; subir o
// app só trocaria a mensagem por um erro de banco.
if (!window.VALIDADOR_INCOMPATIVEL && configuracaoValida()) {
  registrarServiceWorker();
  instalarAlerta();
  AppRegistry.registerComponent('validador', () => App);
  // Os tipos são os do RN, onde `rootTag` é número; no react-native-web é o
  // elemento do DOM.
  AppRegistry.runApplication('validador', {rootTag: raiz as never, initialProps: {}});
}
